import { useContext } from 'react'
import { CustomFilterModalContext } from '@/context/CustomFilterContext'

export const useFilterModal = () => useContext(CustomFilterModalContext)
